module.exports = __webpack_public_path__ + "img/welcome_20.fb355a56.jpg";